import { doorColours } from '@planner/config';
import type { Order } from '@planner/shared';
import { parseDoorsDesign } from '@planner/shared/doors';
import type { CartProperties } from './events.js';
import { track } from './index.js';

export function cartProperties(order: Order): CartProperties {
  return {
    design_reference: order.referenceCode,
    line_count: order.items.length,
    total: order.totals.total,
  };
}

export function trackLineAdded(order: Order, lineId: string): void {
  const design = parseDoorsDesign(order.design);
  const door = design?.doors.find((line) => line.lineId === lineId);
  const index = order.doorLineIds?.indexOf(lineId) ?? -1;
  const item = order.items[index];
  const colour = doorColours.find((entry) => entry.name === door?.snapshot.colourName);
  if (!door || !item || !colour) {
    console.warn('Analytics: the confirmed Cart line could not be matched.');
    return;
  }
  track('cart_line_added', {
    ...cartProperties(order),
    door_type: door.doorType,
    frame_colour: colour.name,
    measure_mode: door.measurements.mode,
    quantity: item.quantity,
    line_total: (Math.round(item.unitPrice * 100) * item.quantity) / 100,
  });
}
